import { ElevationViewStyle as o } from "./index.js";
import { FloorPlanStyle as l } from "./index3.js";
import { FloorPlanStyleBlackWhite as t } from "./index2.js";
const i = {
  elevation: o,
  floorplanBW: t,
  floorplan: l
};
export {
  i as SvgStyles
};
//# sourceMappingURL=index4.js.map
